// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyClpRFnidcGuJuJb1BrNN5OUkAmcARWcE0",
    authDomain: "lingdisco-staging.firebaseapp.com",
    projectId: "lingdisco-staging",
    storageBucket: "lingdisco-staging.appspot.com",
    messagingSenderId: "819932991052",
    appId: "1:819932991052:web:0b8d0c0bbb3fb2f845eee9",
    measurementId: "G-XVJF2JVL5V"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
